import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import theme from '../../themes/default';
import style from './Badge.style';
import { jsx as ___EmotionJSX } from "@emotion/core";

const Badge = ({
  count,
  color,
  className
}) => ___EmotionJSX("div", {
  css: /*#__PURE__*/_css([style.badge.base({
    color
  }), count != null && style.badge.withCount], ";label:Badge;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0JhZGdlL0JhZGdlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9JIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0JhZGdlL0JhZGdlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgdGhlbWUgZnJvbSAnLi4vLi4vdGhlbWVzL2RlZmF1bHQnO1xuaW1wb3J0IHN0eWxlIGZyb20gJy4vQmFkZ2Uuc3R5bGUnO1xuXG5jb25zdCBCYWRnZSA9ICh7IGNvdW50LCBjb2xvciwgY2xhc3NOYW1lIH0pID0+IChcbiAgPGRpdlxuICAgIGNzcz17W3N0eWxlLmJhZGdlLmJhc2UoeyBjb2xvciB9KSwgY291bnQgIT0gbnVsbCAmJiBzdHlsZS5iYWRnZS53aXRoQ291bnRdfVxuICAgIGNsYXNzTmFtZT17Y2xhc3NOYW1lfVxuICAgIGFyaWEtbGFiZWw9XCJhdmF0YXItYmFkZ2VcIlxuICA+XG4gICAge2NvdW50ICE9IG51bGwgJiYgPHNwYW4gY3NzPXtzdHlsZS5jb3VudC5iYXNlfT57Y291bnR9PC9zcGFuPn1cbiAgPC9kaXY+XG4pO1xuXG5CYWRnZS5kZWZhdWx0UHJvcHMgPSB7XG4gIGNvdW50OiB1bmRlZmluZWQsXG4gIGNvbG9yOiB0aGVtZS5jb2xvci5kZXNpZ25TeXN0ZW0uc3VjY2VzcyxcbiAgY2xhc3NOYW1lOiB1bmRlZmluZWQsXG59O1xuXG5CYWRnZS5wcm9wVHlwZXMgPSB7XG4gIGNvdW50OiBQcm9wVHlwZXMubnVtYmVyLFxuICBjb2xvcjogUHJvcFR5cGVzLnN0cmluZyxcbiAgY2xhc3NOYW1lOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgUmVhY3QubWVtbyhCYWRnZSk7XG4iXX0= */")),
  className: className,
  "aria-label": "avatar-badge"
}, count != null && ___EmotionJSX("span", {
  css: style.count.base
}, count));

Badge.defaultProps = {
  count: undefined,
  color: theme.color.designSystem.success,
  className: undefined
};
Badge.propTypes = {
  count: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string
};
export default React.memo(Badge);
//# sourceMappingURL=Badge.js.map